import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//service
import { setAdminPlusRankingPoints } from "../../../../utils/service/ranking";

function Egs(props) {
  function openLink(link) {
    window.open(link, "_blank");
  }

  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-egs").focus();
  }, []);
  return (
    <section className="section-egs">
      <a id="title-egs" className="title-home" tabIndex={12}>
        Página Expo Área - E S G
      </a>
      <div className="div-cards-egs">
        <div className="card-egs">
          <a className="title-card-egs" id="title-card-egs" tabIndex={13}>
            Pesquisa ESG
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Abrir página pesquisa esg"
            onClick={() => {
              openLink("https://www.survio.com/survey/d/esg");
              pointAction("ESGPESQUISA");
            }}
            tabIndex={14}
          >
            <i
              className="bx bx-link-external"
              style={{ fontSize: 40, cursor: "pointer" }}
              id="egs-link1"
            />
          </button>
        </div>

        <div className="card-egs">
          <a className="title-card-egs" tabIndex={15}>
            PDF ESG
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Baixar pdf esg"
            tabIndex={16}
            onClick={() => {
              openLink(
                "https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/EXPO/STAND%20-%20ESG/V%C3%ADdeo%20ESG.mp4?AWSAccessKeyId=AKIAJ2EWX2HWZM4NBALA&Expires=1698240569&Signature=Q9UzOFbm3W9bDnSRTAjCjiaXMsg%3D"
              );
              pointAction("ESGPDF");
            }}
          >
            <i
              className="bx bx-download"
              style={{ fontSize: 40, cursor: "pointer" }}
              id="egs-link2"
            />
          </button>
        </div>

        {/* <div className="card-egs">
          <a className="title-card-egs" tabIndex={17}>
            SUSTAINABILITY REPORT NTTDATA EMEAL 21/22
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Baixar pdf SUSTAINABILITY REPORT NTTDATA EMEAL 21/22"
            tabIndex={18}
            onClick={() => {
              openLink(
                "https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/EXPO/STAND%20-%20ESG/sustainability-report-nttdata-emeal-21-22.pdf?AWSAccessKeyId=AKIAJ2EWX2HWZM4NBALA&Expires=1698240464&Signature=r3vifoCRfsjFrYvrtZgQ6WM9bcU%3D"
              );
              pointAction("ESGPDFSUSTAINABILITY");
            }}
          >
            <i
              className="bx bx-download"
              style={{ fontSize: 40, cursor: "pointer" }}
              id="egs-link3"
            />
          </button>
        </div> */}

        {/* <div className="card-egs">
          <a className="title-card-egs" tabIndex={19}>
            ESG Vídeo
          </a>
          <video
            tabIndex={20}
            controls
            width={200}
            height={200}
            onPlay={() => pointAction("ESGVIDEO")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/V%C3%ADdeo%20ESG%20%281%29.mp4" />
          </video>
        </div> */}

        <div className="card-egs">
          <a className="title-card-egs" tabIndex={21}>
            Vídeo Rafael
          </a>
          <video
            tabIndex={22}
            controls
            width={200}
            height={200}
            onPlay={() => pointAction("ESGVIDEORAFAEL")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/%C3%81reas%20Expo%20-%20ESG%20%28RAPHAEL%29%20V2_%20SEM%20QR%20CODE%20%281%29.mp4" />
          </video>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(Egs);
